import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_NAME = "/api/social_fund_application_types";

export default {
  getApplicationTypes(params) {
    return Api()
      .get(RESOURCE_NAME, { params })
      .catch((err) => errorHandler(err, null));
  },
};
